module.exports = __webpack_public_path__ + "img/logo1.ee595ac3.png";